/** Where the Knowledge Hub lives, for the screens and dialogs that navigate into it. */
export const KNOWLEDGE_HUB_BASE = '/ui/knowledge-hub';

/** Where a folder's own page lives: its path, under the hub. */
export function folderHref(path: string): string {
  return `${KNOWLEDGE_HUB_BASE}/${path}`;
}
